import { useEffect } from 'react'
import { useLatest } from 'ahooks'

/**
 * 监听文档显隐变化
 * @param {(state: DocumentVisibilityState) => void} fn
 */
export function useVisibilityChange(fn) {
  const fnRef = useLatest(fn)

  useEffect(() => {
    const handler = () => fnRef.current?.(document.visibilityState)

    document.addEventListener('visibilitychange', handler)

    return () => {
      document.removeEventListener('visibilitychange', handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
